import React from 'react';
import {Datagrid, Filter, List, TextField, TextInput} from 'react-admin';
import {EPartnerField} from "./EPartner";

const MerchantGroupFilter = (props) => (
    <Filter {...props}>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
    </Filter>
);

export const ParkingPartnerList = props => (
    <List filters={<MerchantGroupFilter/>} {...props} exporter={false}>
        <Datagrid rowClick={"edit"}>
            <EPartnerField source="partner"/>
            <TextField source="name"/>
            <TextField source="code"/>
        </Datagrid>
    </List>
);

export default ParkingPartnerList
